var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDocument = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4124",
    "data-name": "Grupo 4124",
    transform: "translate(-3.963 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "public-24px",
    transform: "translate(2.03 2.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2333",
    "data-name": "Grupo 2333",
    transform: "translate(1.963 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_1",
    "data-name": "Subtra\\xE7\\xE3o 1",
    d: "M14,16H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H14a2,2,0,0,1,2,2V14A2,2,0,0,1,14,16ZM3.6,10.4a.4.4,0,1,0,0,.8H9.2a.4.4,0,0,0,0-.8Zm0-3.2a.4.4,0,1,0,0,.8h8.8a.4.4,0,1,0,0-.8ZM3.6,4a.4.4,0,1,0,0,.8h8.8a.4.4,0,1,0,0-.8Z",
    transform: "translate(-0.031 -0.03)"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDocument, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/document.dfc8a4c1.svg";
export { ForwardRef as ReactComponent };